import { 
  VENDOR_PROFILE_DETAILS_REQUEST, 
  VENDOR_PROFILE_DETAILS_FAIL, 
  VENDOR_PROFILE_DETAILS_SUCCESS 
} from "../constants/AuthConstant";

import axios from "axios";

const id = localStorage.getItem("vendorid");

// ------------------------------
// Fetch Vendor Profile
// ------------------------------
export const VendorProfile = (vId) => {
  return function (dispatch) {

    dispatch({
      type: VENDOR_PROFILE_DETAILS_REQUEST,
      payload: true,
    });

    const vendorID = vId ? vId : id;

    const OPTION = {
      url: `${process.env.REACT_APP_API_PATH}/ebench/get_vendor_by_vendorId?vendorId=${vendorID}`,
      method: "GET",
      headers: {
        "content-type": "application/json",
      },
    };

    axios(OPTION)
      .then((res) => {
        dispatch(loadAllDetailsPre(res.data));
      })
      .catch((error) => {
        dispatch({
          type: VENDOR_PROFILE_DETAILS_FAIL,
          payload: false,
          error,
          msg: "Failed to load vendor information",
        });
      });
  };
};

// ------------------------------
// Fetch Candidate Vendor Profile (same endpoint)
// ------------------------------
export const CandidateVendorProfile = (candidateVendorId) => {
  return function (dispatch) {

    dispatch({
      type: VENDOR_PROFILE_DETAILS_REQUEST,
      payload: true,
    });

    const vendorID = candidateVendorId ? candidateVendorId : id;

    const OPTION = {
      url: `${process.env.REACT_APP_API_PATH}/ebench/get_vendor_by_vendorId?vendorId=${vendorID}`, // SAME ENDPOINT
      method: "GET",
      headers: {
        "content-type": "application/json",
      },
    };

    axios(OPTION)
      .then((res) => {
        dispatch(loadCandidateVendorDetails(res.data));
      })
      .catch((error) => {
        dispatch({
          type: VENDOR_PROFILE_DETAILS_FAIL,
          payload: false,
          error,
          msg: "Failed to load candidate vendor information",
        });
      });
  };
};

// ------------------------------
// SUCCESS dispatchers
// ------------------------------
export const loadCandidateVendorDetails = (data) => {
  return {
    type: VENDOR_PROFILE_DETAILS_SUCCESS,
    candidateVendor: data,
    isCandidateVendor: true, // <--- this differentiates
    payload: false,
    loading: false,
    msg: "SUCCESS",
  };
};

export const loadAllDetailsPre = (data) => {
  return {
    type: VENDOR_PROFILE_DETAILS_SUCCESS,
    result: data,
    isCandidateVendor: false, // <--- vendor response
    payload: false,
    loading: false,
    msg: "SUCCESS",
  };
};
